import React from 'react';
import { Avatar } from '@chakra-ui/react';
import './coder-avatar.scss';

export type CoderAvatarVariant = 'assigned' | 'available';

export interface CoderAvatarProps {
  name: string;
  variant: CoderAvatarVariant;
}

export const CoderAvatar: React.FC<CoderAvatarProps> = ({ name, variant }) => {
  return (
    <Avatar
      name={name}
      size="sm"
      className={`cmx-coder-avatar cmx-coder-avatar--${variant}`}
    />
  );
};

CoderAvatar.displayName = 'CoderAvatar';
